import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { LoadContatos } from './styles';

const SkeletonContatos: React.FC = () => {
  return (
    <>
      <SkeletonTheme color="#999591" highlightColor="#444">
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
        <LoadContatos>
          <div>
            <Skeleton circle height={40} width={40} />
            <strong>
              <Skeleton width={200} />
            </strong>
          </div>
        </LoadContatos>
      </SkeletonTheme>
    </>
  );
};

export default SkeletonContatos;
